import { render, staticRenderFns } from "./PlaylistsGrid.vue?vue&type=template&id=3496fda7&scoped=true&"
import script from "./PlaylistsGrid.vue?vue&type=script&lang=js&"
export * from "./PlaylistsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistsGrid.vue?vue&type=style&index=0&id=3496fda7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496fda7",
  null
  
)

export default component.exports